import(/* webpackMode: "eager" */ "/builds/PortailVente/mCommerce-SSR/b-you/src/app/error.tsx");
